'use client';

import React from 'react';

import { Box, useSlotRecipe } from '@chakra-ui/react';

import { AdvancedMarker, AdvancedMarkerAnchorPoint } from '@vis.gl/react-google-maps';

import { isMobile } from '@nocowanie/core/helpers';

import { MapPopoverProps } from './map-popover.props';
import { MapPopoverContent } from './map-popover-content';

export const MapPopover = ({
    position,
    zIndex = 10000,
    popoverData,
    isAnchorTop,
    onClose,
}: MapPopoverProps) => {
    const isMobileBrowser = isMobile();
    const recipe = useSlotRecipe({ key: 'mapPopover' });
    const styles = recipe({ variant: isMobileBrowser ? 'mobile' : 'desktop' });
    const anchorPoint = isAnchorTop
        ? AdvancedMarkerAnchorPoint.TOP_CENTER
        : AdvancedMarkerAnchorPoint.BOTTOM_CENTER;

    const commonProps = {
        css: styles.container,
        onClick: (e: React.SyntheticEvent) => e.stopPropagation(),
        onTouchStart: (e: React.TouchEvent) => e.stopPropagation(),
        ...(isMobileBrowser
            ? {}
            : {
                  onMouseDown: (e: React.MouseEvent) => e.stopPropagation(),
                  onDoubleClick: (e: React.MouseEvent) => e.stopPropagation(),
              }),
    };

    const content = (
        <Box {...commonProps}>
            <MapPopoverContent
                onClose={onClose}
                btnStyle={styles.closeButton}
                popoverData={popoverData}
            />
        </Box>
    );

    return isMobileBrowser ? (
        content
    ) : (
        <AdvancedMarker position={position} zIndex={zIndex} anchorPoint={anchorPoint}>
            {content}
        </AdvancedMarker>
    );
};
